import React, { useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import "../Chats.css";

const Message = ({ username, content, sameAuthor }) => {
    const sameAuthorTextStyle = sameAuthor ? "Você" : username;
    const alignTitleStyle = sameAuthor ? "align_right_title_message" : "align_left_title_message";
    const alignContentStyle = sameAuthor ? "align_right_content_message created_by_me" : "align_left_content_message";
    const contentStyle = sameAuthor ? "right_content_message" : "left_content_message";

    return (
        <div className="single_message_chat_container">
            <div className={`title_single_message_chat_container ${alignTitleStyle}`}>
                <small className="title_single_message_chat">{sameAuthorTextStyle}</small>
            </div>

            <div className={`content_single_message_chat_container ${alignContentStyle}`}>
                <p className={`content_single_message_chat ${contentStyle}`}>{content}</p>
            </div>
        </div>
    );
};

const ChatMessages = ({ messages = [] }) => {
    const scrollRef = useRef();

    const messagesWithIds = messages.map((msg) => ({
        ...msg,
        id: msg.id || uuidv4(),
    }));

    useEffect(() => {
        if (scrollRef) {
            scrollRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    return (
        <div className="chat_conversation_container">
            {messagesWithIds.map((message) => {
                return (
                    <Message
                        key={`${message.id}`}
                        username={message.username}
                        content={message.content}
                        sameAuthor={message.sameAuthor}
                    />
                );
            })}

            <div ref={scrollRef}></div>
        </div>
    );
};

export default ChatMessages;